import { useState } from 'react';

import { IconCheckCircleFilled } from '@iwoca/icons';
import { Button, Modal } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import styles from './PennyTransferAction.module.css';
import { TFundingRequirementsSteps } from '../orderFundingRequirements';
import StepItem from '../stepItem/StepItem';
import { PennyTransferModal } from './pennyTransferModal/PennyTransferModal';

export const PennyTransferAction = ({
    status,
    triggerRefetchFundingRequirements
}: {
    status: TFundingRequirementsSteps['0']['status'];
    triggerRefetchFundingRequirements: () => void;
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleModalClose = () => {
        setIsModalOpen(!isModalOpen);
        triggerRefetchFundingRequirements();
    };

    return (
        <>
            <StepItem
                title={
                    <FormattedMessage
                        id="_.funding_requirements.send_penny_transfer_title"
                        defaultMessage="Send a penny transfer"
                    />
                }
                caption={
                    <FormattedMessage
                        id="_.funding_requirements.send_penny_transfer_caption"
                        defaultMessage="This confirms that you control your company's bank account."
                    />
                }
                action={
                    status === 'COMPLETED' ? (
                        <div className={styles.actionIcon}>
                            <IconCheckCircleFilled
                                height="24"
                                width="24"
                                fill="rgba(0, 77, 51, 1)"
                                xlinkTitle="checked"
                            />
                        </div>
                    ) : (
                        <Button
                            variant="primary"
                            onClick={() => setIsModalOpen(true)}
                        >
                            <FormattedMessage
                                id="_.funding_requirements.penny_transfer_action"
                                defaultMessage="Complete transfer"
                            />
                        </Button>
                    )
                }
            />
            <Modal isOpen={isModalOpen} onClose={handleModalClose} closeIcon>
                <PennyTransferModal />
            </Modal>
        </>
    );
};
